module.exports = __webpack_public_path__ + "static/media/grin-tongue-squint.c5387926.svg";